// AUTO-GENERATED by scripts/generateFonts.ts from fonts.json.
// Do NOT edit by hand. Run `bun run fonts` to regenerate.

export type FontCategoryKey = "khmer" | "masterpiece" | "phoenix-digital-art" | "one-type" | "aka" | "saimoon" | "unknown" | "other";

export interface FontDefinition {
  id: string;
  displayName: string;
  category: FontCategoryKey;
  filePath: string;
  cssFamily: string;
  previewFamily: string;
  localName: string;
  downloadFileName: string;
  languages: string[];
}

export interface FontCategory {
  key: FontCategoryKey;
  title: string;
  description: string;
  link: string;
  fonts: FontDefinition[];
}

export interface StyleCategory {
  name: string;
  fonts: string[];
}

export interface LanguageCategory {
  id: string;
  name: string;
}

export const fontCatalog: FontCategory[] = [
  {
    key: "khmer",
    title: "Khmer Type",
    description: "Modern and legacy Unicode fonts from KhmerType collection.",
    link: "https://github.com/khmertype",
    fonts: [
      {
        id: "khmer:MyanmarAngoun",
        displayName: "MyanmarAngoun",
        category: "khmer",
        filePath: "/KhmerType/MyanmarAngoun.ttf",
        cssFamily: "MyanmarAngoun-KhmerType",
        previewFamily: "MMFont-MyanmarAngoun-KhmerType",
        localName: "Myanmar Angoun",
        downloadFileName: "MyanmarAngoun.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarChatu",
        displayName: "MyanmarChatu",
        category: "khmer",
        filePath: "/KhmerType/MyanmarChatu.ttf",
        cssFamily: "MyanmarChatu",
        previewFamily: "MMFont-MyanmarChatu",
        localName: "Myanmar Chatu",
        downloadFileName: "MyanmarChatu.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarChatuLight",
        displayName: "MyanmarChatuLight",
        category: "khmer",
        filePath: "/KhmerType/MyanmarChatuLight.ttf",
        cssFamily: "MyanmarChatuLight",
        previewFamily: "MMFont-MyanmarChatuLight",
        localName: "Myanmar Chatu Light",
        downloadFileName: "MyanmarChatuLight.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarGantgaw",
        displayName: "MyanmarGantgaw",
        category: "khmer",
        filePath: "/KhmerType/MyanmarGantgaw.ttf",
        cssFamily: "MyanmarGantgaw",
        previewFamily: "MMFont-MyanmarGantgaw",
        localName: "Myanmar Gantgaw",
        downloadFileName: "MyanmarGantgaw.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarKhyay",
        displayName: "MyanmarKhyay",
        category: "khmer",
        filePath: "/KhmerType/MyanmarKhyay.ttf",
        cssFamily: "MyanmarKhyay",
        previewFamily: "MMFont-MyanmarKhyay",
        localName: "Myanmar Khyay",
        downloadFileName: "MyanmarKhyay.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarKuttar",
        displayName: "MyanmarKuttar",
        category: "khmer",
        filePath: "/KhmerType/MyanmarKuttar.ttf",
        cssFamily: "MyanmarKuttar",
        previewFamily: "MMFont-MyanmarKuttar",
        localName: "Myanmar Kuttar",
        downloadFileName: "MyanmarKuttar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarNayone",
        displayName: "MyanmarNayone",
        category: "khmer",
        filePath: "/KhmerType/MyanmarNayone.ttf",
        cssFamily: "MyanmarNayone",
        previewFamily: "MMFont-MyanmarNayone",
        localName: "Myanmar Nayone",
        downloadFileName: "MyanmarNayone.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarNjaun",
        displayName: "MyanmarNjaun",
        category: "khmer",
        filePath: "/KhmerType/MyanmarNjaun.ttf",
        cssFamily: "MyanmarNjaun",
        previewFamily: "MMFont-MyanmarNjaun",
        localName: "Myanmar Njaun",
        downloadFileName: "MyanmarNjaun.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarPauklay",
        displayName: "MyanmarPauklay",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPauklay.ttf",
        cssFamily: "MyanmarPauklay",
        previewFamily: "MMFont-MyanmarPauklay",
        localName: "Myanmar Pauklay",
        downloadFileName: "MyanmarPauklay.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarPhetsot",
        displayName: "MyanmarPhetsot",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPhetsot.ttf",
        cssFamily: "MyanmarPhetsot",
        previewFamily: "MMFont-MyanmarPhetsot",
        localName: "Myanmar Phetsot",
        downloadFileName: "MyanmarPhetsot.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarPhiksel",
        displayName: "MyanmarPhiksel",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPhiksel.ttf",
        cssFamily: "MyanmarPhiksel",
        previewFamily: "MMFont-MyanmarPhiksel",
        localName: "Myanmar Phiksel",
        downloadFileName: "MyanmarPhiksel.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarPhikselSmooth",
        displayName: "MyanmarPhikselSmooth",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPhikselSmooth.ttf",
        cssFamily: "MyanmarPhikselSmooth",
        previewFamily: "MMFont-MyanmarPhikselSmooth",
        localName: "Myanmar Phiksel Smooth",
        downloadFileName: "MyanmarPhikselSmooth.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarPonenyet",
        displayName: "MyanmarPonenyet",
        category: "khmer",
        filePath: "/KhmerType/MyanmarPonenyet.ttf",
        cssFamily: "MyanmarPonenyet",
        previewFamily: "MMFont-MyanmarPonenyet",
        localName: "Myanmar Ponenyet",
        downloadFileName: "MyanmarPonenyet.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarSabae",
        displayName: "MyanmarSabae",
        category: "khmer",
        filePath: "/KhmerType/MyanmarSabae.ttf",
        cssFamily: "MyanmarSabae-KhmerType",
        previewFamily: "MMFont-MyanmarSabae-KhmerType",
        localName: "Myanmar Sabae",
        downloadFileName: "MyanmarSabae.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarSagar",
        displayName: "MyanmarSagar",
        category: "khmer",
        filePath: "/KhmerType/MyanmarSagar.ttf",
        cssFamily: "MyanmarSagar",
        previewFamily: "MMFont-MyanmarSagar",
        localName: "Myanmar Sagar",
        downloadFileName: "MyanmarSagar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarSanpya",
        displayName: "MyanmarSanpya",
        category: "khmer",
        filePath: "/KhmerType/MyanmarSanpya.ttf",
        cssFamily: "MyanmarSanpya",
        previewFamily: "MMFont-MyanmarSanpya",
        localName: "Myanmar Sanpya",
        downloadFileName: "MyanmarSanpya.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarTagu",
        displayName: "MyanmarTagu",
        category: "khmer",
        filePath: "/KhmerType/MyanmarTagu.ttf",
        cssFamily: "MyanmarTagu",
        previewFamily: "MMFont-MyanmarTagu",
        localName: "Myanmar Tagu",
        downloadFileName: "MyanmarTagu.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarThuriya",
        displayName: "MyanmarThuriya",
        category: "khmer",
        filePath: "/KhmerType/MyanmarThuriya.ttf",
        cssFamily: "MyanmarThuriya",
        previewFamily: "MMFont-MyanmarThuriya",
        localName: "Myanmar Thuriya",
        downloadFileName: "MyanmarThuriya.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarWaso",
        displayName: "MyanmarWaso",
        category: "khmer",
        filePath: "/KhmerType/MyanmarWaso.ttf",
        cssFamily: "MyanmarWaso",
        previewFamily: "MMFont-MyanmarWaso",
        localName: "Myanmar Waso",
        downloadFileName: "MyanmarWaso.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "khmer:MyanmarYinmar",
        displayName: "MyanmarYinmar",
        category: "khmer",
        filePath: "/KhmerType/MyanmarYinmar.ttf",
        cssFamily: "MyanmarYinmar",
        previewFamily: "MMFont-MyanmarYinmar",
        localName: "Myanmar Yinmar",
        downloadFileName: "MyanmarYinmar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
    ],
  },
  {
    key: "masterpiece",
    title: "Masterpiece",
    description: "Masterpiece Unicode fonts for display and body text.",
    link: "https://sourceforge.net/projects/prahita/files/Myanmar%20Unicode%20Fonts/",
    fonts: [
      {
        id: "masterpiece:MasterpieceCTL",
        displayName: "MasterpieceCTL",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceCTL.ttf",
        cssFamily: "MasterpieceCTL",
        previewFamily: "MMFont-MasterpieceCTL",
        localName: "Masterpiece CTL",
        downloadFileName: "MasterpieceCTL.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceLakwel",
        displayName: "MasterpieceLakwel",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceLakwel.ttf",
        cssFamily: "MasterpieceLakwel",
        previewFamily: "MMFont-MasterpieceLakwel",
        localName: "Masterpiece Lakwel",
        downloadFileName: "MasterpieceLakwel.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceSpringRev",
        displayName: "MasterpieceSpringRev",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceSpringRev.ttf",
        cssFamily: "MasterpieceSpringRev",
        previewFamily: "MMFont-MasterpieceSpringRev",
        localName: "Masterpiece Spring Revolution",
        downloadFileName: "MasterpieceSpringRev.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceStadium",
        displayName: "MasterpieceStadium",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceStadium.ttf",
        cssFamily: "MasterpieceStadium",
        previewFamily: "MMFont-MasterpieceStadium",
        localName: "Masterpiece Stadium",
        downloadFileName: "MasterpieceStadium.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceTawWin",
        displayName: "MasterpieceTawWin",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceTawWin.ttf",
        cssFamily: "MasterpieceTawWin",
        previewFamily: "MMFont-MasterpieceTawWin",
        localName: "Masterpiece Taw Win",
        downloadFileName: "MasterpieceTawWin.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceUniHand",
        displayName: "MasterpieceUniHand",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceUniHand.ttf",
        cssFamily: "MasterpieceUniHand",
        previewFamily: "MMFont-MasterpieceUniHand",
        localName: "Masterpiece Uni HandScript",
        downloadFileName: "MasterpieceUniHand.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceUniRound",
        displayName: "MasterpieceUniRound",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceUniRound.ttf",
        cssFamily: "MasterpieceUniRound",
        previewFamily: "MMFont-MasterpieceUniRound",
        localName: "Masterpiece Uni Round",
        downloadFileName: "MasterpieceUniRound.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceUniSerif",
        displayName: "MasterpieceUniSerif",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceUniSerif.ttf",
        cssFamily: "MasterpieceUniSerif",
        previewFamily: "MMFont-MasterpieceUniSerif",
        localName: "Masterpiece Uni Serif",
        downloadFileName: "MasterpieceUniSerif.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceUniType",
        displayName: "MasterpieceUniType",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceUniType.ttf",
        cssFamily: "MasterpieceUniType",
        previewFamily: "MMFont-MasterpieceUniType",
        localName: "Masterpiece Uni Type",
        downloadFileName: "MasterpieceUniType.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceYayChanZin",
        displayName: "MasterpieceYayChanZin",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceYayChanZin.ttf",
        cssFamily: "MasterpieceYayChanZin",
        previewFamily: "MMFont-MasterpieceYayChanZin",
        localName: "Masterpiece Yay Chan Zin",
        downloadFileName: "MasterpieceYayChanZin.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceDaung",
        displayName: "MasterpieceDaung",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceDaung.ttf",
        cssFamily: "MasterpieceDaung",
        previewFamily: "MMFont-MasterpieceDaung",
        localName: "Masterpiece Daung",
        downloadFileName: "MasterpieceDaung.ttf",
        languages: ["burmese"],
      },
      {
        id: "masterpiece:MasterpieceDaungRound",
        displayName: "MasterpieceDaungRound",
        category: "masterpiece",
        filePath: "/masterpiece/MasterpieceDaungRound.ttf",
        cssFamily: "MasterpieceDaungRound",
        previewFamily: "MMFont-MasterpieceDaungRound",
        localName: "Masterpiece Daung Round",
        downloadFileName: "MasterpieceDaungRound.ttf",
        languages: ["burmese"],
      },
    ],
  },
  {
    key: "phoenix-digital-art",
    title: "Phoenix Digital Art",
    description: "Special purpose font releases from Phoenix Digital Art.",
    link: "https://www.facebook.com/PhoenixDigitalArt",
    fonts: [
      {
        id: "phoenix-digital-art:ThitSarShweSi",
        displayName: "ThitSarShweSi",
        category: "phoenix-digital-art",
        filePath: "/PhoenixDigitalArt/ThitSarShweSi.ttf",
        cssFamily: "ThitSarShweSi",
        previewFamily: "MMFont-ThitSarShweSi",
        localName: "Thit Sar Shwe Si",
        downloadFileName: "ThitSarShweSi.ttf",
        languages: ["burmese"],
      },
    ],
  },
  {
    key: "one-type",
    title: "One Type",
    description: "Free font releases from One Type.",
    link: "https://www.facebook.com/onetype.fontstudio",
    fonts: [
      {
        id: "one-type:OneTypeChiangMai",
        displayName: "OneTypeChiangMai",
        category: "one-type",
        filePath: "/OneType/OneTypeChiangMai.ttf",
        cssFamily: "OneTypeChiangMai",
        previewFamily: "MMFont-OneTypeChiangMai",
        localName: "OT Free01_ChiangMai",
        downloadFileName: "OneTypeChiangMai.ttf",
        languages: ["burmese"],
      },
      {
        id: "one-type:OneTypeMMDot",
        displayName: "OneTypeMMDot",
        category: "one-type",
        filePath: "/OneType/OneTypeMMDot.ttf",
        cssFamily: "OneTypeMMDot",
        previewFamily: "MMFont-OneTypeMMDot",
        localName: "OT Free02_mmDot",
        downloadFileName: "OneTypeMMDot.ttf",
        languages: ["burmese"],
      },
    ],
  },
  {
    key: "aka",
    title: "A Ka",
    description: "A Ka Myanmar Unicode font family.",
    link: "https://www.facebook.com/profile.php?id=61570100936629",
    fonts: [
      {
        id: "aka:Aka01-Bold",
        displayName: "Aka01-Bold",
        category: "aka",
        filePath: "/Aka/Aka01-Bold.ttf",
        cssFamily: "Aka01-Bold",
        previewFamily: "MMFont-Aka01-Bold",
        localName: "A ka 01",
        downloadFileName: "Aka01-Bold.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka01-Medium",
        displayName: "Aka01-Medium",
        category: "aka",
        filePath: "/Aka/Aka01-Medium.ttf",
        cssFamily: "Aka01-Medium",
        previewFamily: "MMFont-Aka01-Medium",
        localName: "A ka 01",
        downloadFileName: "Aka01-Medium.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka01-Regular",
        displayName: "Aka01-Regular",
        category: "aka",
        filePath: "/Aka/Aka01-Regular.ttf",
        cssFamily: "Aka01-Regular",
        previewFamily: "MMFont-Aka01-Regular",
        localName: "A ka 01",
        downloadFileName: "Aka01-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka011-Bold",
        displayName: "Aka011-Bold",
        category: "aka",
        filePath: "/Aka/Aka011-Bold.ttf",
        cssFamily: "Aka011-Bold",
        previewFamily: "MMFont-Aka011-Bold",
        localName: "A ka -011",
        downloadFileName: "Aka011-Bold.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka011-Light",
        displayName: "Aka011-Light",
        category: "aka",
        filePath: "/Aka/Aka011-Light.ttf",
        cssFamily: "Aka011-Light",
        previewFamily: "MMFont-Aka011-Light",
        localName: "A ka -011",
        downloadFileName: "Aka011-Light.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka011-Regular",
        displayName: "Aka011-Regular",
        category: "aka",
        filePath: "/Aka/Aka011-Regular.ttf",
        cssFamily: "Aka011-Regular",
        previewFamily: "MMFont-Aka011-Regular",
        localName: "A ka -011",
        downloadFileName: "Aka011-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka02-Regular",
        displayName: "Aka02-Regular",
        category: "aka",
        filePath: "/Aka/Aka02-Regular.ttf",
        cssFamily: "Aka02-Regular",
        previewFamily: "MMFont-Aka02-Regular",
        localName: "A ka 02",
        downloadFileName: "Aka02-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka03-Regular",
        displayName: "Aka03-Regular",
        category: "aka",
        filePath: "/Aka/Aka03-Regular.ttf",
        cssFamily: "Aka03-Regular",
        previewFamily: "MMFont-Aka03-Regular",
        localName: "A ka 03",
        downloadFileName: "Aka03-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka05-Regular",
        displayName: "Aka05-Regular",
        category: "aka",
        filePath: "/Aka/Aka05-Regular.ttf",
        cssFamily: "Aka05-Regular",
        previewFamily: "MMFont-Aka05-Regular",
        localName: "A ka 05",
        downloadFileName: "Aka05-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka06-Regular",
        displayName: "Aka06-Regular",
        category: "aka",
        filePath: "/Aka/Aka06-Regular.ttf",
        cssFamily: "Aka06-Regular",
        previewFamily: "MMFont-Aka06-Regular",
        localName: "A ka 06",
        downloadFileName: "Aka06-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka08-Regular",
        displayName: "Aka08-Regular",
        category: "aka",
        filePath: "/Aka/Aka08-Regular.ttf",
        cssFamily: "Aka08-Regular",
        previewFamily: "MMFont-Aka08-Regular",
        localName: "A ka 08",
        downloadFileName: "Aka08-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka09-Regular",
        displayName: "Aka09-Regular",
        category: "aka",
        filePath: "/Aka/Aka09-Regular.ttf",
        cssFamily: "Aka09-Regular",
        previewFamily: "MMFont-Aka09-Regular",
        localName: "A ka 09",
        downloadFileName: "Aka09-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "aka:Aka10-Light",
        displayName: "Aka10-Light",
        category: "aka",
        filePath: "/Aka/Aka10-Light.ttf",
        cssFamily: "Aka10-Light",
        previewFamily: "MMFont-Aka10-Light",
        localName: "A ka 10",
        downloadFileName: "Aka10-Light.ttf",
        languages: ["burmese"],
      },
    ],
  },
  {
    key: "saimoon",
    title: "Sai Moon",
    description: "Sai Moon Unicode font family.",
    link: "https://www.facebook.com/21.11creative/",
    fonts: [
      {
        id: "saimoon:SM01_WaTokeLay-Regular",
        displayName: "SM01_WaTokeLay-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM01_WaTokeLay-Regular.ttf",
        cssFamily: "SM01_WaTokeLay-Regular",
        previewFamily: "MMFont-SM01_WaTokeLay-Regular",
        localName: "SM01_WaTokeLay",
        downloadFileName: "SM01_WaTokeLay-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM02_KanBaung-Regular",
        displayName: "SM02_KanBaung-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM02_KanBaung-Regular.ttf",
        cssFamily: "SM02_KanBaung-Regular",
        previewFamily: "MMFont-SM02_KanBaung-Regular",
        localName: "SM02_KanBaung",
        downloadFileName: "SM02_KanBaung-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM03_KaWai-Regular",
        displayName: "SM03_KaWai-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM03_KaWai-Regular.ttf",
        cssFamily: "SM03_KaWai-Regular",
        previewFamily: "MMFont-SM03_KaWai-Regular",
        localName: "SM03_KaWai",
        downloadFileName: "SM03_KaWai-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM04Moon-Italic",
        displayName: "SM04Moon-Italic",
        category: "saimoon",
        filePath: "/SaiMoon/SM04Moon-Italic.ttf",
        cssFamily: "SM04Moon-Italic",
        previewFamily: "MMFont-SM04Moon-Italic",
        localName: "SM04_Moon",
        downloadFileName: "SM04Moon-Italic.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM04_Moon-Bold",
        displayName: "SM04_Moon-Bold",
        category: "saimoon",
        filePath: "/SaiMoon/SM04_Moon-Bold.ttf",
        cssFamily: "SM04_Moon-Bold",
        previewFamily: "MMFont-SM04_Moon-Bold",
        localName: "SM04_Moon",
        downloadFileName: "SM04_Moon-Bold.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM04_Moon-Regular",
        displayName: "SM04_Moon-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM04_Moon-Regular.ttf",
        cssFamily: "SM04_Moon-Regular",
        previewFamily: "MMFont-SM04_Moon-Regular",
        localName: "SM04_Moon",
        downloadFileName: "SM04_Moon-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM04_Moon-Thin",
        displayName: "SM04_Moon-Thin",
        category: "saimoon",
        filePath: "/SaiMoon/SM04_Moon-Thin.ttf",
        cssFamily: "SM04_Moon-Thin",
        previewFamily: "MMFont-SM04_Moon-Thin",
        localName: "SM04_Moon",
        downloadFileName: "SM04_Moon-Thin.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM06_LaikPyar-Bold",
        displayName: "SM06_LaikPyar-Bold",
        category: "saimoon",
        filePath: "/SaiMoon/SM06_LaikPyar-Bold.ttf",
        cssFamily: "SM06_LaikPyar-Bold",
        previewFamily: "MMFont-SM06_LaikPyar-Bold",
        localName: "SM06_LaikPyar",
        downloadFileName: "SM06_LaikPyar-Bold.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM06_LaikPyar-Regular",
        displayName: "SM06_LaikPyar-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM06_LaikPyar-Regular.ttf",
        cssFamily: "SM06_LaikPyar-Regular",
        previewFamily: "MMFont-SM06_LaikPyar-Regular",
        localName: "SM06_LaikPyar",
        downloadFileName: "SM06_LaikPyar-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM06_LaikPyar-Straight",
        displayName: "SM06_LaikPyar-Straight",
        category: "saimoon",
        filePath: "/SaiMoon/SM06_LaikPyar-Straight.ttf",
        cssFamily: "SM06_LaikPyar-Straight",
        previewFamily: "MMFont-SM06_LaikPyar-Straight",
        localName: "SM06_LaikPyar",
        downloadFileName: "SM06_LaikPyar-Straight.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM06_LaikPyar-Thin",
        displayName: "SM06_LaikPyar-Thin",
        category: "saimoon",
        filePath: "/SaiMoon/SM06_LaikPyar-Thin.ttf",
        cssFamily: "SM06_LaikPyar-Thin",
        previewFamily: "MMFont-SM06_LaikPyar-Thin",
        localName: "SM06_LaikPyar",
        downloadFileName: "SM06_LaikPyar-Thin.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM07_Virus-Regular",
        displayName: "SM07_Virus-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM07_Virus-Regular.ttf",
        cssFamily: "SM07_Virus-Regular",
        previewFamily: "MMFont-SM07_Virus-Regular",
        localName: "SM07_Virus",
        downloadFileName: "SM07_Virus-Regular.ttf",
        languages: ["burmese"],
      },
      {
        id: "saimoon:SM08_AntiVirus-Regular",
        displayName: "SM08_AntiVirus-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM08_AntiVirus-Regular.ttf",
        cssFamily: "SM08_AntiVirus-Regular",
        previewFamily: "MMFont-SM08_AntiVirus-Regular",
        localName: "SM08_AntiVirus",
        downloadFileName: "SM08_AntiVirus-Regular.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
      },
      {
        id: "saimoon:SM09_BeeZee-Regular",
        displayName: "SM09_BeeZee-Regular",
        category: "saimoon",
        filePath: "/SaiMoon/SM09_BeeZee-Regular.otf",
        cssFamily: "SM09_BeeZee-Regular",
        previewFamily: "MMFont-SM09_BeeZee-Regular",
        localName: "SM09_BeeZee",
        downloadFileName: "SM09_BeeZee-Regular.otf",
        languages: ["burmese"],
      },
    ],
  },
  {
    key: "unknown",
    title: "Unknown Author",
    description: "Community fonts with unknown or mixed attribution.",
    link: "",
    fonts: [
      {
        id: "unknown:CherryUnicode",
        displayName: "CherryUnicode",
        category: "unknown",
        filePath: "/unknown/CherryUnicode.ttf",
        cssFamily: "CherryUnicode",
        previewFamily: "MMFont-CherryUnicode",
        localName: "Cherry Unicode",
        downloadFileName: "CherryUnicode.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:Kamjing",
        displayName: "Kamjing",
        category: "unknown",
        filePath: "/unknown/Kamjing.ttf",
        cssFamily: "Kamjing",
        previewFamily: "MMFont-Kamjing",
        localName: "Kamjing-2",
        downloadFileName: "Kamjing.ttf",
        languages: ["burmese","rakhine","karen"],
      },
      {
        id: "unknown:MyanmarBlack",
        displayName: "MyanmarBlack",
        category: "unknown",
        filePath: "/unknown/MyanmarBlack.ttf",
        cssFamily: "MyanmarBlack",
        previewFamily: "MMFont-MyanmarBlack",
        localName: "Myanmar Black",
        downloadFileName: "MyanmarBlack.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:MyanmarHeadOne",
        displayName: "MyanmarHeadOne",
        category: "unknown",
        filePath: "/unknown/MyanmarHeadOne.ttf",
        cssFamily: "MyanmarHeadOne",
        previewFamily: "MMFont-MyanmarHeadOne",
        localName: "Myanmar Head One",
        downloadFileName: "MyanmarHeadOne.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:MyanmarSquare",
        displayName: "MyanmarSquare",
        category: "unknown",
        filePath: "/unknown/MyanmarSquare.ttf",
        cssFamily: "MyanmarSquare",
        previewFamily: "MMFont-MyanmarSquare",
        localName: "Myanmar Square",
        downloadFileName: "MyanmarSquare.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:MyanmarSquareLight",
        displayName: "MyanmarSquareLight",
        category: "unknown",
        filePath: "/unknown/MyanmarSquareLight.ttf",
        cssFamily: "MyanmarSquareLight",
        previewFamily: "MMFont-MyanmarSquareLight",
        localName: "Myanmar Square Light",
        downloadFileName: "MyanmarSquareLight.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:NKSSmart2",
        displayName: "NKSSmart2",
        category: "unknown",
        filePath: "/unknown/NKSSmart2.ttf",
        cssFamily: "NKSSmart2",
        previewFamily: "MMFont-NKSSmart2",
        localName: "NK SSmart2",
        downloadFileName: "NKSSmart2.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:NKSSmart3",
        displayName: "NKSSmart3",
        category: "unknown",
        filePath: "/unknown/NKSSmart3.ttf",
        cssFamily: "NKSSmart3",
        previewFamily: "MMFont-NKSSmart3",
        localName: "NK SSmart3",
        downloadFileName: "NKSSmart3.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:NKSSmart4",
        displayName: "NKSSmart4",
        category: "unknown",
        filePath: "/unknown/NKSSmart4.ttf",
        cssFamily: "NKSSmart4",
        previewFamily: "MMFont-NKSSmart4",
        localName: "NK SSmart4",
        downloadFileName: "NKSSmart4.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:NamKhoneUnicode",
        displayName: "NamKhoneUnicode",
        category: "unknown",
        filePath: "/unknown/NamKhoneUnicode.ttf",
        cssFamily: "NamKhoneUnicode",
        previewFamily: "MMFont-NamKhoneUnicode",
        localName: "NamKhoneUnicode",
        downloadFileName: "NamKhoneUnicode.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:Yangon",
        displayName: "Yangon",
        category: "unknown",
        filePath: "/unknown/Yangon.ttf",
        cssFamily: "Yangon",
        previewFamily: "MMFont-Yangon",
        localName: "Yangon",
        downloadFileName: "Yangon.ttf",
        languages: ["burmese"],
      },
      {
        id: "unknown:YoeYar-One",
        displayName: "YoeYar-One",
        category: "unknown",
        filePath: "/unknown/YoeYar-One.ttf",
        cssFamily: "YoeYar-One",
        previewFamily: "MMFont-YoeYar-One",
        localName: "YoeYar-One",
        downloadFileName: "YoeYar-One.ttf",
        languages: ["burmese"],
      },
      {
        id: "unknown:MyanmarAngoun",
        displayName: "MyanmarAngoun",
        category: "unknown",
        filePath: "/unknown/MyanmarAngoun.ttf",
        cssFamily: "MyanmarAngoun-UnknownAuthor",
        previewFamily: "MMFont-MyanmarAngoun-UnknownAuthor",
        localName: "Myanmar Angoun",
        downloadFileName: "MyanmarAngoun.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:MyanmarSabae",
        displayName: "MyanmarSabae",
        category: "unknown",
        filePath: "/unknown/MyanmarSabae.ttf",
        cssFamily: "MyanmarSabae-UnknownAuthor",
        previewFamily: "MMFont-MyanmarSabae-UnknownAuthor",
        localName: "Myanmar Sabae",
        downloadFileName: "MyanmarSabae.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "unknown:MyanmarSansPro",
        displayName: "MyanmarSansPro",
        category: "unknown",
        filePath: "/unknown/MyanmarSansPro.ttf",
        cssFamily: "MyanmarSansPro-UnknownAuthor",
        previewFamily: "MMFont-MyanmarSansPro-UnknownAuthor",
        localName: "Myanmar Sans Pro",
        downloadFileName: "MyanmarSansPro.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
    ],
  },
  {
    key: "other",
    title: "Other Fonts",
    description: "Additional Myanmar Unicode families from multiple sources.",
    link: "",
    fonts: [
      {
        id: "other:Mon3",
        displayName: "Mon3",
        category: "other",
        filePath: "/other/Mon3.ttf",
        cssFamily: "Mon3",
        previewFamily: "MMFont-Mon3",
        localName: "MON3 Anonta 1",
        downloadFileName: "Mon3.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "other:Myanmar3",
        displayName: "Myanmar3",
        category: "other",
        filePath: "/other/Myanmar3.TTF",
        cssFamily: "Myanmar3",
        previewFamily: "MMFont-Myanmar3",
        localName: "Myanmar3",
        downloadFileName: "Myanmar3.TTF",
        languages: ["burmese"],
      },
      {
        id: "other:MyanmarSansPro",
        displayName: "MyanmarSansPro",
        category: "other",
        filePath: "/other/MyanmarSansPro.ttf",
        cssFamily: "MyanmarSansPro-Other",
        previewFamily: "MMFont-MyanmarSansPro-Other",
        localName: "Myanmar Sans Pro",
        downloadFileName: "MyanmarSansPro.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "other:NotoSanMyanmar",
        displayName: "NotoSanMyanmar",
        category: "other",
        filePath: "/other/NotoSanMyanmar.ttf",
        cssFamily: "NotoSanMyanmar",
        previewFamily: "MMFont-NotoSanMyanmar",
        localName: "NotoSansMyanmarRegular",
        downloadFileName: "NotoSanMyanmar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "other:NotoSansMyanmarUI",
        displayName: "NotoSansMyanmarUI",
        category: "other",
        filePath: "/other/NotoSansMyanmarUI.ttf",
        cssFamily: "NotoSansMyanmarUI",
        previewFamily: "MMFont-NotoSansMyanmarUI",
        localName: "Noto Sans Myanmar UI",
        downloadFileName: "NotoSansMyanmarUI.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "other:NotoZawDecode",
        displayName: "NotoZawDecode",
        category: "other",
        filePath: "/other/NotoSansMyanmarUI-Regular-ZawDecode.ttf",
        cssFamily: "NotoZawDecode",
        previewFamily: "MMFont-NotoZawDecode",
        localName: "Noto Sans Myanmar UI",
        downloadFileName: "NotoSansMyanmarUI-Regular-ZawDecode.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
      },
      {
        id: "other:NotoSerifMyanmar",
        displayName: "NotoSerifMyanmar",
        category: "other",
        filePath: "/other/NotoSerifMyanmar.ttf",
        cssFamily: "NotoSerifMyanmar",
        previewFamily: "MMFont-NotoSerifMyanmar",
        localName: "Noto Serif Myanmar",
        downloadFileName: "NotoSerifMyanmar.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
      },
      {
        id: "other:Ours-Unicode",
        displayName: "Ours-Unicode",
        category: "other",
        filePath: "/other/Ours-Unicode.ttf",
        cssFamily: "Ours-Unicode",
        previewFamily: "MMFont-Ours-Unicode",
        localName: "Ours-Unicode",
        downloadFileName: "Ours-Unicode.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "other:Pyidaungsu",
        displayName: "Pyidaungsu",
        category: "other",
        filePath: "/other/Pyidaungsu.ttf",
        cssFamily: "Pyidaungsu",
        previewFamily: "MMFont-Pyidaungsu",
        localName: "Pyidaungsu",
        downloadFileName: "Pyidaungsu.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
      },
      {
        id: "other:Yunghkio",
        displayName: "Yunghkio",
        category: "other",
        filePath: "/other/Yunghkio.ttf",
        cssFamily: "Yunghkio",
        previewFamily: "MMFont-Yunghkio",
        localName: "Yunghkio",
        downloadFileName: "Yunghkio.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","khamti"],
      },
      {
        id: "other:MyMyanmarUniversal",
        displayName: "MyMyanmarUniversal",
        category: "other",
        filePath: "/other/MyMyanmarUniversal.ttf",
        cssFamily: "MyMyanmarUniversal",
        previewFamily: "MMFont-MyMyanmarUniversal",
        localName: "!MyMyanmar Universal",
        downloadFileName: "MyMyanmarUniversal.ttf",
        languages: ["burmese"],
      },
      {
        id: "other:NotoSansMyanmar",
        displayName: "NotoSansMyanmar",
        category: "other",
        filePath: "/other/NotoSansMyanmar-Regular.ttf",
        cssFamily: "NotoSansMyanmar",
        previewFamily: "MMFont-NotoSansMyanmar",
        localName: "NotoSansMyanmar",
        downloadFileName: "NotoSansMyanmar-Regular.ttf",
        languages: ["burmese","mon","shan","rakhine","karen","pao","tailaing","khamti"],
      },
    ],
  },
];

export const allFonts: FontDefinition[] = fontCatalog.flatMap((category) => category.fonts);

export const fontStyleCategories: StyleCategory[] = [
  {
    name: "Handwritten / Script",
    fonts: ["MasterpieceLakwel", "MasterpieceUniHand", "MasterpieceYayChanZin", "ThitSarShweSi", "Aka05-Regular", "Aka09-Regular", "SM01_WaTokeLay-Regular", "SM09_BeeZee-Regular"],
  },
  {
    name: "Sans-Serif / Clean UI",
    fonts: ["MyanmarAngoun", "MyanmarGantgaw", "MyanmarNayone", "MyanmarNjaun", "MyanmarPauklay", "MyanmarPhetsot", "MyanmarSabae", "MyanmarSagar", "MyanmarSanpya", "MyanmarTagu", "MyanmarThuriya", "MyanmarWaso", "MyanmarYinmar", "MasterpieceStadium", "Aka01-Bold", "Aka01-Medium", "Aka01-Regular", "Aka011-Bold", "Aka011-Light", "Aka011-Regular", "CherryUnicode", "Kamjing", "NKSSmart2", "NKSSmart3", "NKSSmart4", "NamKhoneUnicode", "Yangon", "MyanmarSansPro", "Mon3", "Myanmar3", "NotoSanMyanmar", "NotoSansMyanmarUI", "NotoZawDecode", "Ours-Unicode", "Pyidaungsu", "Yunghkio", "MyMyanmarUniversal", "NotoSansMyanmar"],
  },
  {
    name: "Serif / Traditional",
    fonts: ["MasterpieceTawWin", "MasterpieceUniSerif", "YoeYar-One", "NotoSerifMyanmar"],
  },
  {
    name: "Rounded",
    fonts: ["MasterpieceUniRound", "MasterpieceDaungRound", "Aka10-Light"],
  },
  {
    name: "Square / Blocky",
    fonts: ["MyanmarChatu", "MyanmarChatuLight", "MyanmarKhyay", "MyanmarKuttar", "MyanmarPhikselSmooth", "MyanmarPonenyet", "Aka06-Regular", "MyanmarHeadOne", "MyanmarSquare", "MyanmarSquareLight", "SM04Moon-Italic", "SM04_Moon-Bold", "SM04_Moon-Regular", "SM04_Moon-Thin"],
  },
  {
    name: "Typewriter / Monospaced",
    fonts: ["MasterpieceUniType"],
  },
  {
    name: "Display / Decorative",
    fonts: ["MyanmarPhiksel", "MasterpieceCTL", "MasterpieceSpringRev", "MasterpieceDaung", "OneTypeChiangMai", "OneTypeMMDot", "Aka02-Regular", "Aka03-Regular", "Aka08-Regular", "MyanmarBlack", "SM02_KanBaung-Regular", "SM03_KaWai-Regular", "SM06_LaikPyar-Bold", "SM06_LaikPyar-Regular", "SM06_LaikPyar-Straight", "SM06_LaikPyar-Thin", "SM07_Virus-Regular", "SM08_AntiVirus-Regular"],
  },
];

export const fontLanguageCategories: LanguageCategory[] = [
  {
    id: "burmese",
    name: "Burmese",
  },
  {
    id: "mon",
    name: "Mon",
  },
  {
    id: "shan",
    name: "Shan",
  },
  {
    id: "rakhine",
    name: "Rakhine",
  },
  {
    id: "karen",
    name: "Karen",
  },
  {
    id: "pao",
    name: "Pa'O",
  },
  {
    id: "tailaing",
    name: "Tai Laing",
  },
  {
    id: "khamti",
    name: "Khamti",
  },
];
